// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserProfile__container-e6375b {
  --padding: 24px;
}

.UserProfile__header-ad9f83 {
  display: flex;
  padding-bottom: 12px;
  padding-inline-start: var(--padding);
}

.UserProfile__avatar-b9de6f {
  display: flex;
  align-items: flex-start;
  margin-inline-end: 16px;
}

.UserProfile__info-cc7be1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding-inline-end: 64px;
}

.UserProfile__title-e95e56 {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-9);
  color: var(--base-110);
  word-break: break-all;
}

.UserProfile__subtitle-f0d647 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  margin-top: 4px;
}

.UserProfile__actions-df62ef {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 4px 24px 16px;
}

.UserProfile__action-button-d56628 {
  margin-inline-start: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.UserProfile__action-button-icon-cd5bc5 {
  display: flex;
  align-items: center;
}

.UserProfile__contact-e5cb4e {
  padding: 8px var(--padding);
}

.UserProfile__list-item-bae016 {
  min-height: 48px;
  padding: 0 var(--padding);
}

.UserProfile__list-icon-eba796 {
  fill: var(--base-80);
}

.UserProfile__notifications-f11eb9 {
  position: relative;
}

.UserProfile__switch-c08f0b {
  position: absolute;
  top: 21px;
  right: var(--padding);
}

.UserProfile__badge-eef70e {
  margin-top: -4px;
}

.UserProfile__active-call-button-e3e1db {
  margin-inline-start: 16px;
  width: 40px;
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/UserProfile/UserProfile.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,oBAAA;EACA,oCAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,wBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,qBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,qBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;AACF","sourcesContent":[".container {\n  --padding: 24px;\n}\n\n.header {\n  display: flex;\n  padding-bottom: 12px;\n  padding-inline-start: var(--padding);\n}\n\n.avatar {\n  display: flex;\n  align-items: flex-start;\n  margin-inline-end: 16px;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-sizing: border-box;\n  padding-inline-end: 64px;\n}\n\n.title {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-9);\n  color: var(--base-110);\n  word-break: break-all;\n}\n\n.subtitle {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n  margin-top: 4px;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 4px 24px 16px;\n}\n\n.action-button {\n  margin-inline-start: 16px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.action-button-icon {\n  display: flex;\n  align-items: center;\n}\n\n.contact {\n  padding: 8px var(--padding);\n}\n\n.list-item {\n  min-height: 48px;\n  padding: 0 var(--padding);\n}\n\n.list-icon {\n  fill: var(--base-80);\n}\n\n.notifications {\n  position: relative;\n}\n\n.switch {\n  position: absolute;\n  top: 21px;\n  right: var(--padding);\n}\n\n.badge {\n  margin-top: -4px;\n}\n\n.active-call-button {\n  margin-inline-start: 16px;\n  width: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UserProfile__container-e6375b`,
	"header": `UserProfile__header-ad9f83`,
	"avatar": `UserProfile__avatar-b9de6f`,
	"info": `UserProfile__info-cc7be1`,
	"title": `UserProfile__title-e95e56`,
	"subtitle": `UserProfile__subtitle-f0d647`,
	"actions": `UserProfile__actions-df62ef`,
	"action-button": `UserProfile__action-button-d56628`,
	"actionButton": `UserProfile__action-button-d56628`,
	"action-button-icon": `UserProfile__action-button-icon-cd5bc5`,
	"actionButtonIcon": `UserProfile__action-button-icon-cd5bc5`,
	"contact": `UserProfile__contact-e5cb4e`,
	"list-item": `UserProfile__list-item-bae016`,
	"listItem": `UserProfile__list-item-bae016`,
	"list-icon": `UserProfile__list-icon-eba796`,
	"listIcon": `UserProfile__list-icon-eba796`,
	"notifications": `UserProfile__notifications-f11eb9`,
	"switch": `UserProfile__switch-c08f0b`,
	"badge": `UserProfile__badge-eef70e`,
	"active-call-button": `UserProfile__active-call-button-e3e1db`,
	"activeCallButton": `UserProfile__active-call-button-e3e1db`
};
module.exports = ___CSS_LOADER_EXPORT___;
